
export const SpinnerSimple = () => {
  return (
    <span className="simpleloader"></span>
  )
}
